import { Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { FtcSourcingSummaryService } from './ftc-sourcing-summary.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  gridPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import {
  AppkitDropdownItem,
  findAppkitItemByValue,
  getAppkitDropdownSelection,
  mapToAppkitDropdownItems,
  syncAppkitDropdownSelection
} from '../../../shared/utils/appkit-dropdown.util';
import {
  handleNamedDropdownSelect,
  refreshNamedDropdown,
  setFormDropdownAriaLabel
} from '../../shared/ftc-form-dropdown.support';

@Component({
    selector: 'gtw-ftc-sourcing-summary',
    templateUrl: './ftc-sourcing-summary.component.html',
    styleUrls: ['./ftc-sourcing-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FtcSourcingSummaryComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();
  private isInitialized = false;
  GENERAL_CONFIG: any = {};
  private globalParams: any = {};
  filterParams: any = {};

  minimise = false;
  loadingData = true;
  loadingDataMoreOptions = true;
  loadingData_changeSource = false;
  loadingData_new = false;
  loadingDataQar = true;
  saveFlag = false;
  isSaveClicked = false;
  crudLoading = false;
  enableMoreOptions = false;
  enableSaveButton = false;

  logged_in_user = '';
  curentyear = '';
  scenario = '';
  jcd_key: any;
  scenarioDesc = '';

  selectedRows: any[] = [];
  gridDataMultipleSelect: any = null;

  is_locked: any = null;
  isScenarioLocked = false;
  defaultTag = false;
  assestSourcing = false;

  selectedGieKey: any;
  selectedGieType = '';
  selectedGieName = '';
  selectedTransCatgName = '';
  is_wh_tax = 'N';

  dynamicColumns: string[] = [];
  private attribToDisplay: any[] = [];

  sourceByData: any[] = [];
  sourceByDataView: AppkitDropdownItem[] = [];
  selectedSourceTypeItem: AppkitDropdownItem | null = null;
  basketCodeDataView: AppkitDropdownItem[] = [];
  fdiiCodeDataView: AppkitDropdownItem[] = [];
  setFormDropdownAriaLabel = setFormDropdownAriaLabel;
  selectedSourceType: any = null;
  selectedSourceTypeDesc = '';
  previousSourceType: any = null;

  accountSourcingData: any[] = [];
  moreAccountsToShow: any[] = [];
  TotalData: any[] = [];
  firstTimeMoreAccountsData: any[] = [];
  firstTimeLoad: boolean | undefined;
  previousSelectedGie: any[] = [];

  moreOptionsData: any[] = [];
  moreOptionsDataWH: any[] = [];
  dropdownLists: { [k: string]: any[] } = { moreOptions: [], moreOptionsWH: [] };
  uniqueGieMoreOptionsList: any[] = [];
  selectedGieTypes: any[] = [];

  checkAllButton = false;

  // QAR fields
  qarRadioButton = '';
  qarRadioButtonBkp = '';
  qarRadioKey: any;
  rafOptionAmountPercentage: any;
  codeMastDataTempData: any[] = [];
  basketCodeData: any[] = [];
  fdiiCodeData: any[] = [];
  qarOptions: any[] = [];
  methodCodeData: any[] = [];
  baseBasketCodeData: any[] = [];
  baseFDIICodeData: any[] = [];
  gieType = '';
  customRowList: any[] = [];
  copyCustomRowList: any[] = [];
  customRowDetails: any[] = [];
  isEditMode = false;
  totalAmount: any = 0;
  tempTotalAmount = 0;
  RafDataList: any[] = [];
  totalApprAmount = 0;
  apprAmount: any;
  apprPercentage: any;
  apprPercentageAmount: any;
  rafAmountFlagDisable = '';
  ExamRafType = '';
  tiCCGieKey: any;
  defaultTagAmount: any;
  newPercentage: any;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private sourcingService: FtcSourcingSummaryService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalParams = header.globalParams || {};
    const userSettings = header.userSettingsData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.gridDataMultipleSelect = gridPayloadFromActiveScreen(activeScreen);
    this.logged_in_user = userSettings.sso_id || userSettings.user?.sso_id || '';
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG?.base_url) return;
    this.isInitialized = true;

    this.curentyear = this.filterParams.tax_year || this.globalParams.tax_year;
    this.scenario = this.filterParams.scenario || this.globalParams.scenario;
    this.jcd_key = this.globalParams.jcd_key || 250;

    this.loadingData = true;
    this.selectedRows = [];
    this.processGridData();
    this.checkLockStatus();
    this.getAttribNamebyGieName();
    if (this.scenarioDesc === 'EXAM') {
      this.getTIforGieCCkey();
    }
    this.cdr.detectChanges();
  }

  private processGridData(): void {
    if (!this.gridDataMultipleSelect) return;
    const gd = this.gridDataMultipleSelect;
    const row = gd.rowData;
    if (!row) return;

    this.assestSourcing = (row.GIE_TYPE === 'ASTEXP' || row.GIE_TYPE === 'INVESTMENTS');

    if (gd.colData?.map === 'EDIT') {
      this.selectedRows.push(row);
    }
    if (this.selectedRows.length > 0) {
      this.scenarioDesc = this.selectedRows[0].SCENARIO_DESC || '';
    }
  }

  private checkLockStatus(): void {
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: 'n10cpv', p_scenario: this.scenario, p_jcd_key: this.jcd_key
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        this.is_locked = data.jsonObject;
        if (this.is_locked?.[0]?.LOCK_STATUS === 'Y') {
          this.isScenarioLocked = true;
          this.defaultTag = true;
          this.cdr.detectChanges();
        }
      }
    });
  }

  // ─── Attribute & Source Type Loading ─────────────────────────────────

  getAttribNamebyGieName(): void {
    if (this.selectedRows.length === 0) {
      this.loadingData = false;
      this.cdr.detectChanges();
      return;
    }
    const row = this.selectedRows[0];
    this.selectedGieKey = row.GIE_KEY ?? row.gie_key;
    this.selectedGieType = row.GIE_TYPE;
    this.selectedGieName = row.GROSS_INC_EXP;
    this.selectedTransCatgName = row.TRANS_CATG_NAME;

    if ((row.SOURCE_FLAG === 'CUSTOM' || row.SOURCE_FLAG === 'BI CUSTOM')
      && row.MODULE_NAME !== 'DRD' && row.MODULE_NAME !== 'FGNPCS'
      && row.MODULE_NAME !== 'GHOST' && row.MODULE_NAME !== '8916A'
      && row.STATUS_FLAG !== 'Locked' && row.IS_CHANGED !== 'Yes') {
      this.defaultTag = false;
    } else {
      this.defaultTag = true;
    }
    if (this.is_locked?.[0]?.LOCK_STATUS === 'Y') {
      this.defaultTag = true;
    }

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: 'mo2qhs', gie_key: this.selectedGieKey,
      trans_catg_name: this.selectedTransCatgName, module_name: row.MODULE_NAME
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject?.length > 0 && data.jsonObject[0].IS_WITHHOLDING_TAX === 'Y'
        && row.MODULE_NAME !== 'FTC' && row.MODULE_NAME !== 'EXTPCS') {
        this.defaultTag = true;
        this.enableMoreOptions = true;
        this.is_wh_tax = 'Y';
      }
      this.cdr.detectChanges();
    });

    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: '6qd7am', gie_name: this.selectedGieName
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        this.attribToDisplay = data.jsonObject;
        this.dynamicColumns = this.attribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
        this.getSourceTypeData();
      }
      this.cdr.detectChanges();
    });
  }

  hasColumn(name: string): boolean {
    return this.dynamicColumns.indexOf(name) > -1;
  }

  compareGieTypes(a: any, b: any): boolean {
    return a && b && a.GIE_KEY == b.GIE_KEY;
  }

  getSourceTypeData(): void {
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', { action_code: '7vwqqt' }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        this.sourceByData = data.jsonObject;
        const row = this.selectedRows[0];
        this.selectedSourceTypeDesc = row?.SOURCE_TYPE_0 || '';
        const existing = _.find(this.sourceByData, ['CODE_DISP_DESC', row?.SOURCE_TYPE_0]);
        if (existing) {
          this.selectedSourceType = existing.CODE_KEY;
          this.previousSourceType = existing.CODE_KEY;
        }
        this.refreshFormDropdowns();
        if (this.selectedGieType !== 'GP' && !this.defaultTag) {
          _.remove(this.sourceByData, { CODE_DISP_DESC: 'Summary' });
        }
        if (this.selectedGieType === 'INC' && !this.defaultTag) {
          _.remove(this.sourceByData, { CODE_DISP_DESC: 'Percentage' });
        }
        this.getAccountSourcingData();
        this.cdr.detectChanges();
      }
    });
  }

  onSourceTypeChange(): void {
    const selected = _.find(this.sourceByData, ['CODE_KEY', this.selectedSourceType]);
    this.selectedSourceTypeDesc = selected?.CODE_DISP_DESC || '';
    this.getAccountSourcingData();
  }

  changeSourceBy(): void {
    if (confirm('Change Source by will delete all sourced data')) {
      this.loadingData_changeSource = true;
      this.cdr.detectChanges();
      const row = this.selectedRows[0];
      this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
        action_code: 'p58j84', tag_key: row.TAG_KEY, gie_key: this.selectedGieKey,
        source_by: this.selectedSourceType, tag_cc_key: row.COMBINATION_KEY,
        asset_flag: this.assestSourcing ? 'Y' : 'N',
        p_scenario: this.scenario, p_jcd_key: this.jcd_key
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data?.errorMessage?.length > 0 && data.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.saveFlag = true;
          this.accountSourcingData = data.jsonObject || [];
          this.TotalData = _.filter(this.accountSourcingData, (p: any) => _.includes(['Total'], p.ACCT));
          _.remove(this.accountSourcingData, { ACCT: 'Total' });
          const exists = _.find(this.sourceByData, ['CODE_KEY', this.selectedSourceType]);
          if (exists) this.selectedSourceTypeDesc = exists.CODE_DISP_DESC;
          this.requestGridUpdate.emit('refresh');
        }
        this.loadingData_changeSource = false;
        this.cdr.detectChanges();
      });
      this.moreAccountsToShow = [];
      this.uniqueGieMoreOptionsList = [];
      this.getMoreOptionsData();
      this.selectedGieTypes = [];
      this.previousSourceType = this.selectedSourceType;
    } else {
      this.selectedSourceType = this.previousSourceType;
      this.cdr.detectChanges();
    }
  }

  // ─── Account Data Loading ───────────────────────────────────────────

  /** Keeps primary-GIE account rows when API mixes multiple ALT_GIE_KEY entries (legacy == compare). */
  private filterPrimaryAccountRows(rows: any[]): any[] {
    if (!rows?.length || this.selectedGieKey == null) {
      return rows || [];
    }
    const primary = rows.filter(
      (obj: any) => obj.GIE_KEY == this.selectedGieKey || obj.ALT_GIE_KEY == this.selectedGieKey
    );
    return primary.length > 0 ? primary : rows;
  }

  getAccountSourcingData(): void {
    this.loadingData = true;
    this.cdr.detectChanges();
    const row = this.selectedRows[0];
    let params: any;
    if (this.selectedSourceTypeDesc === 'Summary') {
      params = {
        action_code: 'bxpuay', tag_key: row?.TAG_KEY, gie_key: this.selectedGieKey,
        tag_cc_key: row?.COMBINATION_KEY, p_scenario: this.scenario,
        p_jcd_key: this.jcd_key, more_options: this.is_wh_tax
      };
    } else {
      params = {
        action_code: 'q3lxgm', tag_key: row?.TAG_KEY, gie_key: this.selectedGieKey,
        tag_cc_key: row?.COMBINATION_KEY, asset_flag: this.assestSourcing ? 'Y' : 'N',
        p_scenario: this.scenario, p_jcd_key: this.jcd_key
      };
    }
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        const rows = Array.isArray(data?.jsonObject) ? data.jsonObject : [];
        this.accountSourcingData = rows;
        this.uniqueGieMoreOptionsList = _.uniqBy(this.accountSourcingData, 'ALT_GIE_KEY');
        this.TotalData = _.filter(this.accountSourcingData, (p: any) => _.includes(['Total'], p.ACCT));
        _.remove(this.accountSourcingData, { ACCT: 'Total' });
        if (this.uniqueGieMoreOptionsList.length > 0) {
          this.accountSourcingData = this.filterPrimaryAccountRows(this.accountSourcingData);
        }
        this.getMoreOptionsData();
        this.loadingData = false;
        this.cdr.detectChanges();
      },
      () => { this.accountSourcingData = []; this.loadingData = false; this.cdr.detectChanges(); }
    );
  }

  // ─── More Options ───────────────────────────────────────────────────

  getMoreOptionsData(): void {
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', { action_code: 'njanfg', gie_key: this.selectedGieKey }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (data?.jsonObject) {
          this.moreOptionsData = data.jsonObject;
          if (this.enableMoreOptions) {
            this.moreOptionsDataWH = [];
            this.moreOptionsData.forEach((item: any, index: number) => {
              if (item.GIE_SHORT_DESC === 'WithHolding Taxes') this.moreOptionsDataWH.push(this.moreOptionsData[index]);
            });
          }
          this.syncDropdownList('moreOptions', this.moreOptionsData);
          this.syncDropdownList('moreOptionsWH', this.moreOptionsDataWH);
          this.autoCheckMoreOptionsGie();
        }
        this.cdr.detectChanges();
      }
    );
  }

  autoCheckMoreOptionsGie(): void {
    const matchedGIEKeys: any[] = [];
    if (this.moreOptionsData && this.uniqueGieMoreOptionsList) {
      this.uniqueGieMoreOptionsList.forEach((defaultData: any) => {
        this.moreOptionsData.forEach((item: any) => {
          if (defaultData.ALT_GIE_KEY == item.GIE_KEY) matchedGIEKeys.push(item);
        });
      });
      this.selectedGieTypes = matchedGIEKeys;
      this.previousSelectedGie = _.cloneDeep(this.selectedGieTypes);
      if (this.firstTimeLoad === undefined) this.firstTimeLoad = true;
    }
  }

  getMoreAccounts(): void {
    if (this.firstTimeLoad === false) {
      if (!confirm('Change More Options will reset Amount to Source for More Options. Do you want to continue?')) {
        this.getMoreOptionsData();
        this.selectedGieTypes = this.previousSelectedGie;
        this.cdr.detectChanges();
        return;
      }
    }
    this.loadingData_new = true;
    this.saveFlag = true;
    let gieTypeSelected = '';
    for (const d of this.selectedGieTypes) {
      if (d?.GIE_KEY != null) { gieTypeSelected += d.GIE_KEY + ','; }
    }
    if (gieTypeSelected.length > 0) {
      if (this.enableMoreOptions && this.moreOptionsDataWH.length === 1) this.enableSaveButton = true;
      const row = this.selectedRows[0];
      this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
        action_code: 'q3lxgm', tag_key: row.TAG_KEY, gie_key: this.selectedGieKey,
        more_options: gieTypeSelected.substring(0, gieTypeSelected.length - 1),
        tag_cc_key: row.COMBINATION_KEY, asset_flag: this.assestSourcing ? 'Y' : 'N',
        p_scenario: this.scenario, p_jcd_key: this.jcd_key
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data?.jsonObject) {
          this.moreAccountsToShow = data.jsonObject;
          _.remove(this.moreAccountsToShow, { ACCT: 'Total' });
          if (this.firstTimeLoad) {
            this.firstTimeMoreAccountsData = _.cloneDeep(this.moreAccountsToShow);
            this.firstTimeLoad = false;
          }
        }
        this.loadingData = false;
        this.loadingData_new = false;
        this.cdr.detectChanges();
      });
      this.previousSelectedGie = this.selectedGieTypes;
    } else {
      this.moreAccountsToShow = [];
      this.uniqueGieMoreOptionsList = [];
      this.getMoreOptionsData();
      this.selectedGieTypes = [];
      this.loadingData = false;
      this.loadingData_new = false;
      this.cdr.detectChanges();
    }
  }

  // ─── Amount / Percentage Updates ────────────────────────────────────

  updateRemainder(data: any, type: string): void {
    if (type === 'book') {
      data.BOOK_REMAINDER = parseInt(data.BOOK_TOTAL_AMT || 0) - parseInt(data.BOOK_SOURCE_AMT || 0)
        - (data.BOOK_AMOUNT_TO_SOURCE == null ? 0 : parseInt(data.BOOK_AMOUNT_TO_SOURCE));
      if ((data.BOOK_AMOUNT_TO_SOURCE == null || data.BOOK_AMOUNT_TO_SOURCE === 0) && data.OPERATION_TYPE !== 'I')
        data.OPERATION_TYPE = 'C';
    } else if (type === 'schM' && data.SCHDM_AMOUNT_TO_SOURCE != null) {
      data.SCHDM_REMAINDER = (data.SCHDM_TOTAL_AMT || 0) - (data.SCHDM_SOURCE_AMT || 0) - data.SCHDM_AMOUNT_TO_SOURCE;
      if ((data.SCHDM_AMOUNT_TO_SOURCE == null || data.SCHDM_AMOUNT_TO_SOURCE === 0) && data.OPERATION_TYPE !== 'I')
        data.OPERATION_TYPE = 'C';
    }
    this.saveFlag = true;
    this.cdr.detectChanges();
  }

  updatePercentRemainder(data: any, type: string): void {
    if (type === 'book' && data.BOOK_PERCENT != null) {
      data.BOOK_REMAINDER = data.BOOK_TOTAL_AMT - data.BOOK_SOURCE_AMT - ((data.BOOK_TOTAL_AMT * data.BOOK_PERCENT) / 100);
      data.NEW_BOOK_AMOUNT_TO_SOURCE = (data.BOOK_TOTAL_AMT * data.BOOK_PERCENT) / 100;
      if ((data.BOOK_PERCENT == null || data.BOOK_PERCENT === 0) && data.OPERATION_TYPE !== 'I')
        data.OPERATION_TYPE = 'C';
    } else if (data.SCHDM_PERCENT != null) {
      data.SCHDM_REMAINDER = data.SCHDM_TOTAL_AMT - data.SCHDM_SOURCE_AMT - ((data.SCHDM_TOTAL_AMT * data.SCHDM_PERCENT) / 100);
      data.NEW_SCHDM_AMOUNT_TO_SOURCE = (data.SCHDM_TOTAL_AMT * data.SCHDM_PERCENT) / 100;
      if ((data.SCHDM_PERCENT == null || data.SCHDM_PERCENT === 0) && data.OPERATION_TYPE !== 'I')
        data.OPERATION_TYPE = 'C';
    }
    this.saveFlag = true;
    this.cdr.detectChanges();
  }

  checkAll(): void {
    if (this.checkAllButton) {
      for (const item of this.accountSourcingData) {
        item.SOURCED_CHECKBOX = true;
        if (item.ACCT === 'Total' || item.ALT_GIE_NAME === item.SYS_ACCT) item.SOURCED_CHECKBOX = false;
      }
      for (const item of this.moreAccountsToShow) {
        item.SOURCED_CHECKBOX = true;
        if (item.ACCT === 'Total' || item.ALT_GIE_NAME === item.SYS_ACCT) item.SOURCED_CHECKBOX = false;
      }
    } else {
      for (const item of this.accountSourcingData) { item.SOURCED_CHECKBOX = false; }
      for (const item of this.moreAccountsToShow) { item.SOURCED_CHECKBOX = false; }
    }
    this.cdr.detectChanges();
  }

  // ─── QAR / EXAM Logic ──────────────────────────────────────────────

  getTIforGieCCkey(): void {
    const row = this.selectedRows[0];
    if (!row) return;
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: 'zf7hlu',
      cc_key: row.COMBINATION_KEY, p_scenario: this.scenario, p_jcd_key: this.jcd_key,
      gie_key: row.GIE_KEY, issue_id: row.ISSUE_KEY || 0
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject?.length > 0) {
        this.tiCCGieKey = data.jsonObject[0].TI_AMOUNT;
        this.defaultTagAmount = data.jsonObject[0].DEFAULT_AMOUNT;
        this.getSelectedQAROption();
      } else {
        this.loadingDataQar = false;
        this.cdr.detectChanges();
      }
    });
  }

  getSelectedQAROption(): void {
    const row = this.selectedRows[0];
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: '76vbl7',
      cc_key: row.COMBINATION_KEY, p_scenario: this.scenario, p_jcd_key: this.jcd_key,
      gie_key: row.GIE_KEY, issue_id: row.ISSUE_KEY || 0
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject?.length > 0) {
        this.qarRadioButton = data.jsonObject[0].CODE_DESC;
        this.qarRadioButtonBkp = this.qarRadioButton;
      }
      if (!this.qarRadioButton) { this.loadingDataQar = false; }
      else { this.getCodeMastData(); }
      this.cdr.detectChanges();
    });
  }

  getCodeMastData(): void {
    if (this.qarRadioButtonBkp && this.qarRadioButtonBkp !== this.qarRadioButton) {
      this.changeQarOptions();
      return;
    }
    this.loadingDataQar = true;
    this.cdr.detectChanges();
    const row = this.selectedRows[0];
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: '31hizx', cc_key: row.COMBINATION_KEY,
      p_scenario: this.scenario, p_jcd_key: this.jcd_key
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        this.codeMastDataTempData = data.jsonObject;
        this.basketCodeData = _.filter(data.jsonObject, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
        this.fdiiCodeData = _.filter(data.jsonObject, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));
        this.qarOptions = _.filter(data.jsonObject, (p: any) => _.includes(['QAR_OPTIONS'], p.CODE_GROUP));
        this.methodCodeData = _.filter(data.jsonObject, (p: any) => _.includes(['METHOD_CODE'], p.CODE_GROUP));
        this.baseBasketCodeData = _.filter(data.jsonObject, (p: any) => _.includes(['BASE_BASKET_CODE'], p.CODE_GROUP));
        this.baseFDIICodeData = _.filter(data.jsonObject, (p: any) => _.includes(['BASE_FDII_CODE'], p.CODE_GROUP));

        this.gieType = (row.GIE_TYPE === 'INC' || row.GIE_TYPE === 'GP') ? 'GI' : 'EXP';

        if (this.qarRadioButton === 'By Custom') {
          _.remove(this.basketCodeData, { CODE_DESCRIPTION: 'Default' });
          this.refreshCustomRowDropdownViews();
          this.getCustomPopUpData();
        } else if (this.qarRadioButton === 'By RAF') {
          this.getQARByRAFData();
        }
      }
      this.cdr.detectChanges();
    });
  }

  getQARByRAFData(): void {
    this.RafDataList = [];
    this.totalAmount = 0;
    this.totalApprAmount = 0;
    this.apprPercentage = 0;
    this.apprAmount = undefined;
    const row = this.selectedRows[0];
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: 'jw3c7l', cc_key: row.COMBINATION_KEY,
      p_scenario: this.scenario, p_jcd_key: this.jcd_key,
      gie_key: row.GIE_KEY, gie_type: row.GIE_TYPE, issue_id: row.ISSUE_KEY || 0
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        this.totalAmount = 0;
        this.totalApprAmount = 0;
        this.RafDataList = data.jsonObject;
        if (this.RafDataList.length === 0) this.isSaveClicked = true;

        if (this.RafDataList.length > 0 && this.gieType === 'GI') {
          for (const t of this.RafDataList) {
            this.totalAmount = parseInt(this.totalAmount) + parseInt(t.RAF_AMOUNT);
            if (t.SOURCE_FLAG === 'DEFAULT' || t.SOURCE_FLAG === 'BI DEFAULT') {
              t.CHECKBOX = 0;
            } else { t.CHECKBOX = 1; }
            if (t.CHECKBOX === 0) {
              this.apprPercentage = 1;
              this.apprPercentageAmount = this.tiCCGieKey;
              this.rafAmountFlagDisable = 'Y';
              this.ExamRafType = t.EXAM_RAF_TYPE;
              this.totalApprAmount = parseInt('' + this.totalApprAmount) + parseInt(t.RAF_AMOUNT);
            }
          }
          this.apprAmount = this.RafDataList[0].QAR_AMOUNT;
          if (this.ExamRafType === 'By RAF - Amount') { this.rafAmountFlagDisable = 'N'; }
          if (this.ExamRafType === 'By RAF - Percentage') {
            this.apprPercentageAmount = this.apprAmount;
            this.apprPercentage = parseFloat((this.apprAmount / this.totalApprAmount).toFixed(5));
            this.apprAmount = undefined;
            this.rafAmountFlagDisable = 'Y';
          }
        }

        if (this.RafDataList.length > 0 &&
          (row.GROSS_INC_EXP === 'EXPAA' || row.GROSS_INC_EXP === 'INTEXP' || row.GROSS_INC_EXP === 'ASTEXP')) {
          for (const t of this.RafDataList) {
            if (t.CHECKBOX === 0) this.ExamRafType = t.EXAM_RAF_TYPE;
            if (t.SOURCE_FLAG === 'DEFAULT' || t.SOURCE_FLAG === 'BI DEFAULT') {
              t.CHECKBOX = 0;
              t.QAR_PERCENTAGE = 1;
              t.QAR_PERCENT_AMOUNT = this.tiCCGieKey;
              this.rafAmountFlagDisable = 'Y';
            } else { t.CHECKBOX = 1; }
          }
          if (this.ExamRafType === 'By RAF - Amount') { this.rafAmountFlagDisable = 'N'; }
          if (this.ExamRafType === 'By RAF - Percentage') {
            this.rafAmountFlagDisable = 'Y';
            for (const t of this.RafDataList) {
              t.QAR_PERCENT_AMOUNT = t.QAR_AMOUNT;
              t.QAR_PERCENTAGE = parseFloat((t.QAR_AMOUNT / this.tiCCGieKey).toFixed(5));
              t.QAR_AMOUNT = undefined;
            }
          }
        }
      }
      this.loadingDataQar = false;
      this.cdr.detectChanges();
    });
  }

  updateTotalApprAmount(data: any): void {
    if (this.gieType === 'GI') {
      this.totalApprAmount = data.CHECKBOX === 1
        ? this.totalApprAmount - data.RAF_AMOUNT
        : this.totalApprAmount + data.RAF_AMOUNT;
      this.updateRafAmounts();
    }
  }

  updateRafAmounts(): void {
    if (this.apprAmount == null) {
      this.rafAmountFlagDisable = '';
      this.apprAmount = undefined;
    } else { this.rafAmountFlagDisable = 'N'; }
    for (const t of this.RafDataList) {
      t.QAR_AMOUNT = (t.CHECKBOX === 0 && this.apprAmount !== undefined)
        ? (t.RAF_AMOUNT / this.totalApprAmount) * this.apprAmount : 0;
    }
    this.cdr.detectChanges();
  }

  updateRafPercentage(): void {
    this.isSaveClicked = true;
    if (this.apprPercentage && (this.apprPercentage < 0 || this.apprPercentage > 1)) {
      this.gtwSnackbar.openSnackBar('Please select Ratio between 0 to 1', 'gtw-snackbar--red', true, 5);
    } else {
      this.isSaveClicked = false;
      if (this.apprPercentage == null) {
        this.rafAmountFlagDisable = '';
      } else { this.rafAmountFlagDisable = 'Y'; }
      this.apprPercentageAmount = this.apprPercentage * this.tiCCGieKey;
      for (const t of this.RafDataList) {
        t.QAR_AMOUNT = (t.CHECKBOX === 0 && this.apprPercentage !== undefined)
          ? (t.RAF_AMOUNT / this.totalApprAmount) * this.apprPercentageAmount : 0;
      }
    }
    this.cdr.detectChanges();
  }

  updateRafExpAmount(data: any): void {
    if (data.QAR_AMOUNT == null) { this.rafAmountFlagDisable = ''; data.QAR_AMOUNT = undefined; }
    else { this.rafAmountFlagDisable = 'N'; }
    this.cdr.detectChanges();
  }

  updateRafExpPercentage(data: any): void {
    this.isSaveClicked = true;
    let totalCount = 0;
    for (const item of this.RafDataList) {
      totalCount += (item.QAR_PERCENTAGE || 0);
      if (totalCount > 1) {
        this.gtwSnackbar.openSnackBar('Total percentage cannot be greater than 1', 'gtw-snackbar--red', true, 5);
        return;
      }
    }
    if (data.QAR_PERCENTAGE && (data.QAR_PERCENTAGE < 0 || data.QAR_PERCENTAGE > 1)) {
      this.gtwSnackbar.openSnackBar('Please select Ratio between 0 to 1', 'gtw-snackbar--red', true, 5);
    } else {
      this.isSaveClicked = false;
      if (data.QAR_PERCENTAGE == null) { this.rafAmountFlagDisable = ''; }
      else { data.QAR_AMOUNT = undefined; this.rafAmountFlagDisable = 'Y'; }
      data.QAR_PERCENT_AMOUNT = this.tiCCGieKey * data.QAR_PERCENTAGE;
    }
    this.cdr.detectChanges();
  }

  // ─── Custom QAR ─────────────────────────────────────────────────────

  getCustomPopUpData(): void {
    this.customRowList = [];
    this.totalAmount = 0;
    const row = this.selectedRows[0];
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
      action_code: 'xagg3n', cc_key: row.COMBINATION_KEY,
      p_scenario: this.scenario, p_jcd_key: this.jcd_key,
      gie_key: row.GIE_KEY, issue_id: row.ISSUE_KEY || 0
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        this.customRowDetails = data.jsonObject;
        this.totalAmount = 0;
        if (this.customRowDetails.length > 0) {
          for (const t of this.customRowDetails) {
            const myObject: any = {
              selectedBasketCode: t.BASKET_CODE, selectedFdiiCode: t.FDII_CODE,
              ratio: t.SOURCE_PERCENT, amount: t.AMOUNT, tagKey: t.TAG_KEY,
              OPERATION_TYPE: 'U', disabled: true, ratioDisabled: false
            };
            this.customRowList.push(myObject);
            this.totalAmount = parseInt(this.totalAmount) + parseInt(t.AMOUNT);
            this.isEditMode = true;
            this.qarRadioKey = t.SOURCE_TYPE;
            const exists = _.find(this.qarOptions, ['CODE_KEY', parseInt(t.SOURCE_TYPE)]);
            if (exists) this.qarRadioButton = exists.CODE_DESCRIPTION;
          }
          this.copyCustomRowList = _.cloneDeep(this.customRowList);
        } else {
          const obj: any = {
            selectedBasketCode: undefined, selectedFdiiCode: undefined,
            ratio: undefined, amount: undefined, disabled: '', ratioDisabled: '',
            OPERATION_TYPE: 'I'
          };
          this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', { action_code: 'k5eosd' }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((seqData: any) => {
            obj.tagKey = seqData?.jsonObject?.[0]?.TAG_KEY_SEQ;
            this.customRowList.push(obj);
            this.syncCustomRowDropdownItems();
            this.loadingDataQar = false;
            this.cdr.detectChanges();
          });
        }
        this.syncCustomRowDropdownItems();
      }
      this.loadingDataQar = false;
      this.cdr.detectChanges();
    });
  }

  addRow(): void {
    const tempObj = _.clone(this.customRowList[0]);
    tempObj.selectedBasketCode = undefined;
    tempObj.selectedFdiiCode = undefined;
    tempObj.ratio = undefined;
    tempObj.amount = undefined;
    tempObj.ratioAmountFlag = '';
    tempObj.OPERATION_TYPE = 'I';
    this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', { action_code: 'k5eosd' }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      tempObj.tagKey = data?.jsonObject?.[0]?.TAG_KEY_SEQ;
      this.customRowList.push(tempObj);
      this.syncCustomRowDropdownItems();
      this.cdr.detectChanges();
    });
  }

  validateRatio(data: any): void {
    this.isSaveClicked = true;
    if (data.ratio && (data.ratio < 0 || data.ratio > 1)) {
      this.gtwSnackbar.openSnackBar('Please select Ratio between 0 to 1', 'gtw-snackbar--red', true, 5);
      data.ratio = undefined; data.amount = undefined; data.ratioAmountFlag = '';
      this.recalcCustomTotal();
    } else if (data.ratio === null) {
      this.isSaveClicked = false;
      data.amount = undefined; data.ratioAmountFlag = '';
      this.recalcCustomTotal();
    } else {
      this.isSaveClicked = false;
      data.amount = data.ratio * this.defaultTagAmount;
      data.ratioAmountFlag = 'N';
      this.recalcCustomTotal();
    }
    this.cdr.detectChanges();
  }

  validateAmt(data: any): void {
    this.isSaveClicked = true;
    if (data.amount === null) {
      this.isSaveClicked = false; data.ratio = undefined; data.ratioAmountFlag = '';
    } else {
      this.isSaveClicked = false;
      this.totalAmount = data.amount;
      data.ratioAmountFlag = 'Y';
    }
    this.cdr.detectChanges();
  }

  private recalcCustomTotal(): void {
    this.tempTotalAmount = 0;
    for (const item of this.customRowList) {
      if (item.amount) this.tempTotalAmount += item.amount;
    }
    this.totalAmount = this.tempTotalAmount.toFixed(1);
  }

  changeQarOptions(): void {
    let v_tag_list = '';
    if (this.qarRadioButtonBkp === 'By RAF') {
      for (const t of this.RafDataList) {
        if (t.QAR_TAG_KEY != null) v_tag_list += t.QAR_TAG_KEY + ',';
      }
    }
    if (this.qarRadioButtonBkp === 'By Custom') {
      for (const t of this.customRowList) {
        if (t.tagKey != null) v_tag_list += t.tagKey + ',';
      }
    }
    if (confirm('Changing to By QAR option will delete all the sourced data')) {
      this.jsonObjectFactory.getJSONObj(this.GENERAL_CONFIG.base_url + '/loadJsonObject', {
        action_code: '0nv1s7', tag_key: v_tag_list,
        p_scenario: this.scenario, p_jcd_key: this.jcd_key
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data?.errorMessage?.length > 0 && data.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.requestGridUpdate.emit('refresh');
          this.qarRadioButtonBkp = this.qarRadioButton;
          this.getCodeMastData();
        }
        this.cdr.detectChanges();
      });
    } else {
      this.qarRadioButton = this.qarRadioButtonBkp;
      this.cdr.detectChanges();
    }
  }

  // ─── Percentage Popup (Apply Percentage) ────────────────────────────

  showPercentagePopup = false;
  percentagePopupType: 'book' | 'schM' | 'both' | 'tax' = 'book';

  openPopUpWindow(): void {
    this.showPercentagePopup = true;
    this.newPercentage = undefined;
    this.cdr.detectChanges();
  }

  closePopUpWindow(): void {
    this.showPercentagePopup = false;
    this.cdr.detectChanges();
  }

  saveBookPercentage(): void {
    if (this.newPercentage == null) {
      this.gtwSnackbar.openSnackBar('Please enter a valid percentage', 'gtw-snackbar--red', true, 4);
      return;
    }
    for (const item of this.moreAccountsToShow) {
      if (item.SOURCED_CHECKBOX) {
        item.BOOK_PERCENT = this.newPercentage;
        item.BOOK_REMAINDER = item.BOOK_TOTAL_AMT - item.BOOK_SOURCE_AMT - ((item.BOOK_TOTAL_AMT * item.BOOK_PERCENT) / 100);
        item.NEW_BOOK_AMOUNT_TO_SOURCE = (item.BOOK_TOTAL_AMT * item.BOOK_PERCENT) / 100;
      }
    }
    for (const item of this.accountSourcingData) {
      if (item.SOURCED_CHECKBOX) {
        item.BOOK_PERCENT = this.newPercentage;
        item.BOOK_REMAINDER = item.BOOK_TOTAL_AMT - item.BOOK_SOURCE_AMT - ((item.BOOK_TOTAL_AMT * item.BOOK_PERCENT) / 100);
        item.NEW_BOOK_AMOUNT_TO_SOURCE = (item.BOOK_TOTAL_AMT * item.BOOK_PERCENT) / 100;
      }
    }
    this.saveFlag = true;
    this.showPercentagePopup = false;
    this.cdr.detectChanges();
  }

  saveSchMPercentage(): void {
    if (this.newPercentage == null) {
      this.gtwSnackbar.openSnackBar('Please enter a valid percentage', 'gtw-snackbar--red', true, 4);
      return;
    }
    for (const item of this.moreAccountsToShow) {
      if (item.SOURCED_CHECKBOX) {
        item.SCHDM_PERCENT = this.newPercentage;
        item.SCHDM_REMAINDER = item.SCHDM_TOTAL_AMT - item.SCHDM_SOURCE_AMT - ((item.SCHDM_TOTAL_AMT * item.SCHDM_PERCENT) / 100);
        item.NEW_SCHDM_AMOUNT_TO_SOURCE = (item.SCHDM_TOTAL_AMT * item.SCHDM_PERCENT) / 100;
      }
    }
    for (const item of this.accountSourcingData) {
      if (item.SOURCED_CHECKBOX) {
        item.SCHDM_PERCENT = this.newPercentage;
        item.SCHDM_REMAINDER = item.SCHDM_TOTAL_AMT - item.SCHDM_AMOUNT_TO_SOURCE - ((item.SCHDM_TOTAL_AMT * item.SCHDM_PERCENT) / 100);
        item.NEW_SCHDM_AMOUNT_TO_SOURCE = (item.SCHDM_TOTAL_AMT * item.SCHDM_PERCENT) / 100;
      }
    }
    this.saveFlag = true;
    this.showPercentagePopup = false;
    this.cdr.detectChanges();
  }

  saveBookSchMPercentage(): void {
    this.saveSchMPercentage();
    this.saveBookPercentage();
  }

  removeAccountRow(item: any): void {
    const idx = this.accountSourcingData.indexOf(item);
    if (idx > -1) {
      this.accountSourcingData[idx].SOURCED_CHECKBOX = undefined;
    }
    this.cdr.detectChanges();
  }

  removeOptionsRow(item: any): void {
    const idx = this.moreAccountsToShow.indexOf(item);
    if (idx > -1) {
      this.moreAccountsToShow[idx].SOURCED_CHECKBOX = undefined;
    }
    this.cdr.detectChanges();
  }

  // ─── Save Logic ────────────────────────────────────────────────────

  save(): void {
    this.isSaveClicked = true;
    this.cdr.detectChanges();
    if (!this.saveFlag) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('No changes were made to source data', 'gtw-snackbar--red', true, 4);
      this.cdr.detectChanges();
      return;
    }
    const row = this.selectedRows[0];
    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user, screen_key: this.globalParams.screen_key,
      tag_key: row.TAG_KEY, p_tax_year: this.curentyear,
      p_scenario: this.scenario, p_jcd_key: this.jcd_key
    };
    const allDetails = this.buildSourcingDetails();
    this.sourcingService.saveDefaults(
      this.GENERAL_CONFIG.base_url, this.globalParams, this.filterParams, returnClobSettingsObj, allDetails
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.isSaveClicked = false;
        if (result?.data?.errorMessage && result.data.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(result.data.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar('Data has been successfully saved/updated', 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      () => { this.isSaveClicked = false; this.cdr.detectChanges(); }
    );
  }

  private buildSourcingDetails(): any[] {
    const details: any[] = [];
    const row = this.selectedRows[0];

    for (const acct of this.accountSourcingData) {
      const hasAmtOrSummary = (this.selectedSourceTypeDesc === 'Amount' || this.selectedSourceTypeDesc === 'Summary') &&
        ((acct.BOOK_AMOUNT_TO_SOURCE || 0) !== 0 || (acct.SCHDM_AMOUNT_TO_SOURCE || 0) !== 0 || acct.OPERATION_TYPE === 'C');
      const hasPct = this.selectedSourceTypeDesc === 'Percentage' &&
        ((acct.BOOK_PERCENT || 0) !== 0 || (acct.SCHDM_PERCENT || 0) !== 0 || acct.OPERATION_TYPE === 'C');
      if ((hasAmtOrSummary || hasPct) && acct.ACCT !== 'Total') {
        const ret: any = {
          tag_key: row.TAG_KEY, alt_gie_key: acct.ALT_GIE_KEY,
          acct_key: this.selectedSourceTypeDesc === 'Summary' ? acct.ALT_GIE_KEY : acct.ACCT_KEY,
          operation_type: acct.OPERATION_TYPE === 'C' ? 'U' : acct.OPERATION_TYPE
        };
        if (this.selectedSourceTypeDesc === 'Amount' || this.selectedSourceTypeDesc === 'Summary') {
          ret.source_amt = acct.BOOK_AMOUNT_TO_SOURCE || 0;
          ret.source_percent = 0;
          ret.other_source_amt = acct.SCHDM_AMOUNT_TO_SOURCE || 0;
          ret.other_source_percent = 0;
        } else if (this.selectedSourceTypeDesc === 'Percentage') {
          ret.source_amt = (acct.BOOK_TOTAL_AMT * acct.BOOK_PERCENT) / 100;
          ret.source_percent = acct.BOOK_PERCENT;
          ret.other_source_amt = (acct.SCHDM_TOTAL_AMT * acct.SCHDM_PERCENT) / 100;
          ret.other_source_percent = acct.SCHDM_PERCENT;
        }
        details.push(ret);
      }
    }

    if (this.firstTimeMoreAccountsData?.length > 0) {
      const uniquePrev = _.uniqBy(this.firstTimeMoreAccountsData, 'ALT_GIE_KEY');
      const uniqueNew = _.uniqBy(this.moreAccountsToShow, 'ALT_GIE_KEY');
      const deleted = uniquePrev.filter((item: any) => !uniqueNew.some((other: any) => item.ALT_GIE_KEY === other.ALT_GIE_KEY));
      for (const del of deleted) {
        for (const orig of this.firstTimeMoreAccountsData) {
          if (orig.ALT_GIE_KEY === del.ALT_GIE_KEY) {
            const ret: any = {
              tag_key: row.TAG_KEY, alt_gie_key: orig.ALT_GIE_KEY,
              acct_key: orig.ACCT_KEY, operation_type: 'D'
            };
            if (this.selectedSourceTypeDesc === 'Amount' || this.selectedSourceTypeDesc === 'Summary') {
              ret.source_amt = orig.BOOK_AMOUNT_TO_SOURCE; ret.source_percent = 0;
              ret.other_source_amt = orig.SCHDM_AMOUNT_TO_SOURCE; ret.other_source_percent = 0;
            } else if (this.selectedSourceTypeDesc === 'Percentage') {
              ret.source_amt = (orig.BOOK_TOTAL_AMT * orig.BOOK_PERCENT) / 100;
              ret.source_percent = orig.BOOK_PERCENT;
              ret.other_source_amt = (orig.SCHDM_TOTAL_AMT * orig.SCHDM_PERCENT) / 100;
              ret.other_source_percent = orig.SCHDM_PERCENT;
            }
            details.push(ret);
          }
        }
      }
    }

    for (const mo of this.moreAccountsToShow) {
      const hasAmtOrSummary = (this.selectedSourceTypeDesc === 'Amount' || this.selectedSourceTypeDesc === 'Summary') &&
        ((mo.BOOK_AMOUNT_TO_SOURCE || 0) !== 0 || (mo.SCHDM_AMOUNT_TO_SOURCE || 0) !== 0 || mo.OPERATION_TYPE === 'C');
      const hasPct = this.selectedSourceTypeDesc === 'Percentage' &&
        ((mo.BOOK_PERCENT || 0) !== 0 || (mo.SCHDM_PERCENT || 0) !== 0 || mo.OPERATION_TYPE === 'C');
      if ((hasAmtOrSummary || hasPct) && mo.ACCT !== 'Total') {
        const ret: any = {
          tag_key: row.TAG_KEY, alt_gie_key: mo.ALT_GIE_KEY,
          acct_key: mo.ACCT_KEY, operation_type: mo.OPERATION_TYPE === 'C' ? 'U' : mo.OPERATION_TYPE
        };
        if (this.selectedSourceTypeDesc === 'Amount' || this.selectedSourceTypeDesc === 'Summary') {
          ret.source_amt = mo.BOOK_AMOUNT_TO_SOURCE || 0; ret.source_percent = 0;
          ret.other_source_amt = mo.SCHDM_AMOUNT_TO_SOURCE || 0; ret.other_source_percent = 0;
        } else if (this.selectedSourceTypeDesc === 'Percentage') {
          ret.source_amt = (mo.BOOK_TOTAL_AMT * mo.BOOK_PERCENT) / 100;
          ret.source_percent = mo.BOOK_PERCENT;
          const schdmBase = mo.SCHM_AMT !== undefined ? mo.SCHM_AMT : mo.SCHDM_TOTAL_AMT;
          ret.other_source_amt = (schdmBase * mo.SCHDM_PERCENT) / 100;
          ret.other_source_percent = mo.SCHDM_PERCENT;
        }
        details.push(ret);
      }
    }
    return details;
  }

  saveQARCustom(): void {
    this.isSaveClicked = true;
    this.cdr.detectChanges();
    for (const r of this.customRowList) {
      if (r.selectedBasketCode == null || r.selectedFdiiCode == null || r.ratio === '' || r.amount == null) {
        this.gtwSnackbar.openSnackBar('Please select/enter all the required fields.', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false; this.cdr.detectChanges(); return;
      }
    }
    const exists = _.find(this.qarOptions, ['CODE_DESCRIPTION', this.qarRadioButton]);
    if (exists) this.qarRadioKey = exists.CODE_KEY;
    const row = this.selectedRows[0];
    const qarDetails: any[] = [];
    for (const r of this.customRowList) {
      const ret: any = {
        BASKET: r.selectedBasketCode, FDII: r.selectedFdiiCode, RATIO: r.ratio * 100,
        AMOUNT: r.amount, GIE_KEY: row.GIE_KEY, COMBINATION_KEY: row.COMBINATION_KEY,
        ISSUE_ID: row.ISSUE_KEY, OPERATION_TYPE: r.OPERATION_TYPE,
        QAR_OPTION: this.qarRadioKey, TAG_KEY: r.tagKey
      };
      if (row.GROSS_INC_EXP === 'EXPAA' || row.GROSS_INC_EXP === 'INTEXP' || row.GROSS_INC_EXP === 'ASTEXP') {
        const m = _.find(this.methodCodeData, ['CODE_DESC', 'Allocate']);
        const bb = _.find(this.baseBasketCodeData, ['CODE_DESC', 'SINGLE']);
        const bf = _.find(this.baseFDIICodeData, ['CODE_DESC', 'SINGLE']);
        ret.METHOD = m?.CODE_KEY; ret.BASE_BASKET = bb?.CODE_KEY; ret.BASE_FDII = bf?.CODE_KEY;
      }
      qarDetails.push(ret);
    }
    const settings: any = {
      sso_id: this.logged_in_user, screen_key: this.globalParams.screen_key,
      p_tax_year: this.curentyear, p_scenario: this.scenario, p_jcd_key: this.jcd_key
    };
    this.sourcingService.saveQarCustomTag(
      this.GENERAL_CONFIG.base_url, this.globalParams, this.filterParams, settings, qarDetails
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.isSaveClicked = false;
        if (result?.data?.errorMessage && result.data.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(result.data.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar('Tag has been successfully saved/updated', 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      () => { this.isSaveClicked = false; this.cdr.detectChanges(); }
    );
  }

  saveQARByRaf(): void {
    this.isSaveClicked = true;
    this.cdr.detectChanges();
    const exists = _.find(this.qarOptions, ['CODE_DESCRIPTION', this.qarRadioButton]);
    if (exists) this.qarRadioKey = exists.CODE_KEY;
    const row = this.selectedRows[0];

    if (this.rafAmountFlagDisable === 'N') {
      if (this.gieType === 'GI' && (this.apprAmount == null || this.apprAmount === '')) {
        this.gtwSnackbar.openSnackBar('Please enter QAR Amount or Percentage before you click save.', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false; this.cdr.detectChanges(); return;
      }
      const ex = _.find(this.qarOptions, ['CODE_DESCRIPTION', 'By RAF - Amount']);
      if (ex) this.rafOptionAmountPercentage = ex.CODE_KEY;
    }
    if (this.rafAmountFlagDisable === 'Y') {
      if (this.gieType === 'GI' && (this.apprPercentage == null || this.apprPercentage === '')) {
        this.gtwSnackbar.openSnackBar('Please enter QAR Amount or Percentage before you click save.', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false; this.cdr.detectChanges(); return;
      }
      this.apprAmount = undefined;
      const ex = _.find(this.qarOptions, ['CODE_DESCRIPTION', 'By RAF - Percentage']);
      if (ex) this.rafOptionAmountPercentage = ex.CODE_KEY;
    }

    const qarRafDetails: any[] = [];
    for (const t of this.RafDataList) {
      const ret: any = {
        GIE_KEY: row.GIE_KEY, COMBINATION_KEY: row.COMBINATION_KEY,
        ISSUE_ID: row.ISSUE_KEY, QAR_OPTION: this.qarRadioKey,
        EXAM_RAF_OPTION: this.rafOptionAmountPercentage,
        RAF_TAG_KEY: t.RAF_TAG_KEY, QAR_TAG_KEY: t.QAR_TAG_KEY,
        TOTAL_APPR_AMOUNT: this.totalApprAmount, RAF_AMOUNT: t.RAF_AMOUNT,
        CHECKBOX: t.CHECKBOX
      };

      if ((row.GROSS_INC_EXP === 'EXPAA' || row.GROSS_INC_EXP === 'INTEXP' || row.GROSS_INC_EXP === 'ASTEXP') && t.CHECKBOX === 0) {
        if ((t.QAR_AMOUNT == null || t.QAR_AMOUNT === '') && (t.QAR_PERCENT_AMOUNT == null || t.QAR_PERCENT_AMOUNT === '')) {
          this.gtwSnackbar.openSnackBar('Please enter QAR Amount or Percentage before you click save.', 'gtw-snackbar--red', true, 4);
          this.isSaveClicked = false; this.cdr.detectChanges(); return;
        }
        ret.QAR_AMOUNT = t.QAR_AMOUNT === undefined ? t.QAR_PERCENT_AMOUNT : t.QAR_AMOUNT;
      } else {
        ret.QAR_AMOUNT = this.apprAmount === undefined ? t.QAR_AMOUNT : this.apprAmount;
      }

      if (t.CHECKBOX === 0 && t.QAR_TAG_KEY == null) ret.OPERATION_TYPE = 'I';
      else if (t.CHECKBOX === 1 && t.QAR_TAG_KEY == null) ret.OPERATION_TYPE = 'S';
      else if (t.CHECKBOX === 0 && t.QAR_TAG_KEY != null) ret.OPERATION_TYPE = 'U';
      else if (t.CHECKBOX === 1 && t.QAR_TAG_KEY != null) ret.OPERATION_TYPE = 'D';

      if (ret.OPERATION_TYPE !== 'S') qarRafDetails.push(ret);
    }

    const settings: any = {
      sso_id: this.logged_in_user, screen_key: this.globalParams.screen_key,
      p_tax_year: this.curentyear, p_scenario: this.scenario, p_jcd_key: this.jcd_key
    };
    this.sourcingService.saveQarRafTag(
      this.GENERAL_CONFIG.base_url, this.globalParams, this.filterParams, settings, qarRafDetails
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.isSaveClicked = false;
        if (result?.data?.errorMessage && result.data.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(result.data.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar('Tag has been successfully saved/updated', 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      () => { this.isSaveClicked = false; this.cdr.detectChanges(); }
    );
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  formatNumber(value: any): string {
    if (value == null) return '';
    const num = parseFloat(('' + value).replace(/,/g, ''));
    if (isNaN(num)) return '' + value;
    return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  private refreshFormDropdowns(): void {
    refreshNamedDropdown(this, 'sourceByData', 'selectedSourceType', 'CODE_DISP_DESC', 'CODE_KEY');
    this.selectedSourceTypeItem = syncAppkitDropdownSelection(
      this.sourceByDataView,
      this.selectedSourceType,
      'CODE_DISP_DESC',
      'CODE_KEY'
    );
  }

  private refreshCustomRowDropdownViews(): void {
    this.basketCodeDataView = mapToAppkitDropdownItems(this.basketCodeData, 'CODE_DESCRIPTION', 'CODE_KEY');
    this.fdiiCodeDataView = mapToAppkitDropdownItems(this.fdiiCodeData, 'CODE_DESCRIPTION', 'CODE_KEY');
    this.syncCustomRowDropdownItems();
  }

  private syncCustomRowDropdownItems(): void {
    this.customRowList.forEach((row) => {
      row.selectedBasketCodeItem = findAppkitItemByValue(this.basketCodeDataView, row.selectedBasketCode)
        ?? syncAppkitDropdownSelection(this.basketCodeDataView, row.selectedBasketCode, 'CODE_DESCRIPTION', 'CODE_KEY');
      row.selectedFdiiCodeItem = findAppkitItemByValue(this.fdiiCodeDataView, row.selectedFdiiCode)
        ?? syncAppkitDropdownSelection(this.fdiiCodeDataView, row.selectedFdiiCode, 'CODE_DESCRIPTION', 'CODE_KEY');
    });
  }

  onChangeSourceByFromDropdown(event: any): void {
    handleNamedDropdownSelect(
      event,
      this,
      'selectedSourceTypeItem',
      'selectedSourceType',
      'CODE_DISP_DESC',
      'CODE_KEY',
      'sourceByDataView',
      () => this.changeSourceBy()
    );
  }

  onCustomRowBasketSelect(event: any, row: any): void {
    const selected = getAppkitDropdownSelection(event);
    if (selected) {
      row.selectedBasketCodeItem = selected;
      row.selectedBasketCode = selected.value;
    }
    this.cdr.detectChanges();
  }

  onCustomRowFdiiSelect(event: any, row: any): void {
    const selected = getAppkitDropdownSelection(event);
    if (selected) {
      row.selectedFdiiCodeItem = selected;
      row.selectedFdiiCode = selected.value;
    }
    this.cdr.detectChanges();
  }

  onDropdownSelectItem(_event: any): void {}

  onDropdownFilterResult(key: string, event: any): void {
    this.dropdownLists[key] = event?.result || [];
  }

  private toAppkitOptions(items: any[]): any[] {
    return (items || []).map((item: any) => {
      item.showCheckbox = true;
      item.role = 'checkbox';
      return item;
    });
  }

  private syncDropdownList(key: string, master: any[]): void {
    this.dropdownLists[key] = this.toAppkitOptions(master).slice();
  }

}
